import * as React from 'react';
import {connect} from 'react-redux';

import type {ListQuery} from 'nutshell-core/entities/fetch-list';
import type {LeadStage, FilterObject} from 'nutshell-core/types';
import {VisualPipeline} from 'nutshell-core/visual-pipeline';
import type {StageTransition} from 'nutshell-core/visual-pipeline';

import type {NutshellState} from '../../../store';

import {VisualPipelineColumnCards} from './visual-pipeline-column-cards';
import {VisualPipelineColumnDropTarget} from './visual-pipeline-column-drop-target';
import {VisualPipelineConfirmationColumn} from './visual-pipeline-confirmation-column';

import styles from './visual-pipeline-column.module.css';

type OwnProps = {
    stage: LeadStage;
    filters: Array<FilterObject>;
    selectedSort: string;
    search?: string;
    fieldsToDisplay: string[];
    isLoadingFields: boolean;
};

type DispatchProps = {
    fetchLeadsByStage: (arg1: ListQuery) => any;
};

type StateProps = {
    activeStageTransition: StageTransition;
};

type Props = OwnProps & DispatchProps & StateProps;

const mapStateToProps = function (state: NutshellState): StateProps {
    return {
        activeStageTransition: VisualPipeline.getActiveStageTransition(state),
    };
};

// @ts-expect-error
const mapDispatchToProps = function (dispatch, ownProps: OwnProps): DispatchProps {
    return {
        fetchLeadsByStage: (query) => {
            dispatch(VisualPipeline.fetchLeadsByStage(ownProps.stage.id, query, true));
        },
    };
};

export class VisualPipelineColumnComponent extends React.Component<Props> {
    UNSAFE_componentWillMount() {
        const query = {
            filter: this.props.filters,
            sort: this.props.selectedSort,
            q: this.props.search,
        } as const;

        this.props.fetchLeadsByStage(query);
    }

    UNSAFE_componentWillReceiveProps(nextProps: Props) {
        if (
            JSON.stringify(nextProps.filters) !== JSON.stringify(this.props.filters) ||
            this.props.selectedSort !== nextProps.selectedSort ||
            this.props.search !== nextProps.search
        ) {
            const nextQuery = {
                filter: nextProps.filters,
                sort: nextProps.selectedSort,
                q: nextProps.search,
            } as const;

            this.props.fetchLeadsByStage(nextQuery);
        }
    }

    render() {
        const isConfirmingStageChange =
            this.props.activeStageTransition.toStage === this.props.stage.id;
        const leadIdChangingStage = this.props.activeStageTransition.id;

        return (
            <div className={styles.container}>
                {isConfirmingStageChange && leadIdChangingStage ? (
                    <VisualPipelineConfirmationColumn
                        stageId={this.props.stage.id}
                        selectedSort={this.props.selectedSort}
                        leadId={leadIdChangingStage}
                        fieldsToDisplay={this.props.fieldsToDisplay}
                    />
                ) : (
                    <VisualPipelineColumnDropTarget
                        key={this.props.stage.id}
                        stageId={this.props.stage.id}
                        isConfirmingStageChange={isConfirmingStageChange}
                        isDropTarget={true}
                    >
                        <VisualPipelineColumnCards
                            selectedSort={this.props.selectedSort}
                            stageId={this.props.stage.id}
                            fieldsToDisplay={this.props.fieldsToDisplay}
                            isLoadingFields={this.props.isLoadingFields}
                        />
                    </VisualPipelineColumnDropTarget>
                )}
            </div>
        );
    }
}

// @ts-expect-error
const connector = connect<Props, OwnProps, _, _, _, _>(mapStateToProps, mapDispatchToProps);
export const VisualPipelineColumn = connector(VisualPipelineColumnComponent);
